import { useAuth } from '@/modules/f8/hooks';
import { localize } from "@/locale/i18n"

const auth = useAuth();
export const appRoutes = [
    {
        path: '/', name: 'home',
        component: () => import('@/modules/f8/views/HomeView.vue'),
        meta: { label: localize("mm-main"), icon: 'fas fa-home', layout: 'main' },
    },
    {
        path: '/login', name: 'login',
        component: () => import('@/modules/f8/views/LoginView.vue'),
        meta: { label: localize("mm-login"), layout: 'empty', unauthorized: true },
    },
    {
        path: '/logout', name: 'logout',
        beforeEnter: async (to, from, next) => { await auth.logout(); next('/login?m=XM010'); },
        component: () => import('@/modules/f8/views/RouteStubView.vue'),
        meta: { label: localize("mm-logout"), layout: 'empty' },
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        path: '/agents', name: 'agents',
        component: () => import('@/modules/f8/views/RouteStubView.vue'),
        meta: {
            label: localize("mm-agents"), icon: 'fas fa-user-tie',
            group: 'sidebar', nolink: true,
            sublinks: [
                {
                    path: '/agents/summary', name: 'agents-summary',
                    component: () => import('@/modules/agents/AgentsSummaryView.vue'),
                    meta: { label: localize("mm-agents-summary"), layout: 'main', perm: 'agents:read' },
                },
                {
                    path: '/agents/info', name: 'agents-info',
                    component: () => import('@/modules/agents/AgentInfoView.vue'),
                    meta: { label: localize("mm-agent-info"), layout: 'main', perm: 'agents:read' },
                },
            ],
        },
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        path: '/drivers', name: 'drivers',
        component: () => import('@/modules/f8/views/RouteStubView.vue'),
        meta: {
            label: localize("mm-drivers"), icon: 'fas fa-paw',
            group: 'sidebar', nolink: true,
            sublinks: [
                {
                    path: '/drivers/debt', name: 'debt-management',
                    component: () => import('@/modules/drivers/DebtManagementView.vue'),
                    meta: { label: localize("mm-debt-management"), perm: 'drivers:debt:read' },
                },
                {
                    path: '/drivers/restore', name: 'restore',
                    component: () => import('@/modules/drivers/DeletedDriversView.vue'),
                    meta: { label: "Restore", perm: 'drivers:account:restore' },
                },
                {
                    path: '/drivers/etaxes', name: 'etaxes',
                    component: () => import('@/modules/drivers/EtaxesManagementView.vue'),
                    meta: { label: "eTaxes", perm: 'modetaxes:records:analyse' },
                },
                {
                    path: '/drivers/up', name: 'up',
                    component: () => import('@/modules/f8/views/RouteStubView.vue'),
                    meta: { label: "United Payment", perm: 'drivers:ls:read' },
                },
                {
                    path: '/drivers/bonus', name: 'bonus',
                    component: () => import('@/modules/f8/views/RouteStubView.vue'),
                    meta: { label: "Bonus (weekly)", perm: 'drivers:bonus:read' },
                },
                {
                    path: '/drivers/yigim', name: 'yigim',
                    component: () => import('@/modules/f8/views/RouteStubView.vue'),
                    meta: { label: "Yigim topUp", perm: 'drivers:yigim:read' },
                },
            ],
        },
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        path: '/ayna', name: 'ayna',
        component: () => import('@/modules/f8/views/RouteStubView.vue'),
        meta: {
            label: "AYNA", icon: 'fas fa-poop',
            group: 'sidebar', nolink: true,
            sublinks: [
                {
                    path: '/drivers/buraxilish', name: 'buraxilish',
                    component: () => import('@/modules/f8/views/RouteStubView.vue'),
                    meta: { label: "Buraxilish", perm: 'drivers:buraxilish:read' },
                },
                {
                    path: '/ayna/realtime', name: 'ayna-realtime',
                    component: () => import('@/modules/f8/views/RouteStubView.vue'),
                    meta: { label: "Realtime data", layout: 'main', perm: 'ayna:events:read' },
                },
                {
                    path: '/points/ayna-poly', name: 'points-ayna-poly',
                    component: () => import('@/modules/f8/views/RouteStubView.vue'),
                    meta: { label: "Polygons", layout: 'main', perm: 'points:address:read' },
                },
            ],
        },
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        path: '/corporate', name: 'corporate',
        component: () => import('@/modules/f8/views/RouteStubView.vue'),
        meta: {
            label: "Corporate", icon: 'fas fa-briefcase',
            group: 'sidebar', nolink: true,
            sublinks: [
                {
                    path: '/corporate/pers-discount', name: 'pers-discount',
                    component: () => import('@/modules/acl/views/PermissionsView.vue'),
                    meta: { label: "Personal Discount", perm: 'corp:pers-discount:read' },
                },
                {
                    path: '/corporate/cabinet', name: 'cabinet',
                    component: () => import('@/modules/acl/views/PermissionsView.vue'),
                    meta: { label: "Cabinet", perm: 'corp:cabinet:read' },
                },
            ],
        },
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        path: '/reports', name: 'reports',
        component: () => import('@/modules/f8/views/RouteStubView.vue'),
        meta: {
            label: "Reports", icon: 'fas fa-table-list',
            group: 'sidebar', nolink: true,
            sublinks: [
                {
                    path: '/reports/builder', name: 'report-builder',
                    component: () => import('@/modules/reports/ReportBuilder.vue'),
                    meta: { label: "Report Builder", perm: 'report:builder' },
                },
                {
                    path: '/reports/storage', name: 'report-lstorage',
                    component: () => import('@/modules/reports/ReportBuilder.vue'),
                    meta: { label: "Local storage", perm: 'report:localstorage' },
                },
            ],
        },
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        path: '/points', name: 'points',
        component: () => import('@/modules/f8/views/RouteStubView.vue'),
        meta: {
            label: localize("mm-points"), icon: 'fas fa-map-marked-alt',
            group: 'sidebar', nolink: true,
            sublinks: [
                {
                    path: '/points/address', name: 'address-wide-2',
                    component: () => import('@/modules/points/AddressWideView.vue'),
                    meta: { label: localize("mm-address"), layout: 'wide', perm: 'points:address:read' },
                },
                {
                    path: '/points/timings', name: 'points-timings',
                    component: () => import('@/modules/points/TimingsWideView.vue'),
                    meta: { label: localize("mm-timings"), layout: 'wide', perm: 'points:address:read' },
                }
            ],
        },
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        path: '/tools', name: 'tools',
        component: () => import('@/modules/f8/views/RouteStubView.vue'),
        meta: {
            label: localize("mm-tools"), icon: 'fas fa-tools',
            group: 'sidebar', nolink: true,
            sublinks: [
                {
                    path: '/logs/list', name: 'logrash-logs-list',
                    component: () => import('@/modules/logrash/LogsListView.vue'),
                    meta: { label: localize("mm-logrash-logs"), layout: 'main', perm: 'logrash:logs:read' },
                },
                {
                    path: '/logs/rules', name: 'logrash-logs-rules',
                    component: () => import('@/modules/logrash/LogsRulesView.vue'),
                    meta: { label: localize("mm-logrash-rules"), layout: 'main', perm: 'logrash:rules:read' },
                },
                {
                    path: '/points/cluster', name: 'cluster',
                    component: () => import('@/modules/points/AddressClusterView.vue'),
                    meta: { label: localize("mm-cluster"), layout: 'wide', perm: 'xtra:demo:read' },
                },
                {
                    path: '/demo', name: 'demo',
                    component: () => import('@/modules/f8/views/DemoView.vue'),
                    meta: { label: localize("mm-demo"), perm: 'xtra:demo:read' },
                },
                {
                    path: '/datetime-test', name: 'TestDT',
                    component: () => import('@/modules/f8/views/DatetimeTest.vue'),
                    meta: { label: 'TestDT', perm: 'xtra:demo:read' },
                },
            ],
        },
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        path: '/acl', name: 'acl',
        component: () => import('@/modules/f8/views/RouteStubView.vue'),
        meta: {
            label: localize("mm-acl"), icon: 'fas fa-user-shield',
            group: 'sidebar', nolink: true,
            sublinks: [
                {
                    path: '/users', name: 'users',
                    component: () => import('@/modules/acl/views/UsersView.vue'),
                    meta: { label: localize("mm-users"), perm: 'acl:users:read' },
                },
                {
                    path: '/permissions', name: 'permissions',
                    component: () => import('@/modules/acl/views/PermissionsView.vue'),
                    meta: { label: localize("mm-permissions"), perm: 'acl:perms:read' },
                },
            ],
        },
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        path: '/user-profile', name: 'user-profile',
        component: () => import('@/modules/f8/views/UserProfileView.vue'),
        meta: {
            label: localize("mm-profile"), group: 'sidebar', icon: 'fas fa-cog',
            layout: 'main',
            sublinks: [
                {
                    path: '/logout', name: 'logout',
                    beforeEnter: async (to, from, next) => { await auth.logout(); next('/login?m=XM010'); },
                    component: () => import('@/modules/f8/views/RouteStubView.vue'),
                    meta: { label: localize("mm-logout"), layout: 'empty' },
                }
            ]
        },
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        path: "/:catchAll(.*)", name: "not-found",
        component: () => import('@/modules/f8/views/RouteNotFoundView.vue'),
        meta: { layout: 'main', label: localize("mm-not-found") },
    },
];
